export default "__VITE_ASSET__BzChX2Ln__"